module.exports = __webpack_public_path__ + "media/images/users_blanco-e0a8f29dc20da12d01269949d058b69e.svg";